import Icon from 'components/icon';
import styles from './styles.module.scss';

import { useRef, useState } from 'react';
import useOnClickOutside from 'models/utils/useOnClickOutside';
import useFetchNotificationCount from 'hooks/useFetchNotificationCount';
import Container from './container';
import { useNotifications } from 'context/NotificationContext';

function Notifications() : JSX.Element {
  const ref = useRef(null);
  const [isVisible, changeVisibility] = useState(false);
  const { hasNotifications } = useNotifications();

  useFetchNotificationCount();
  useOnClickOutside(ref, onClick);

  function onClick() : void {
    changeVisibility(!isVisible);
  }

  return (
    <>
      <div id={styles['biobar-notifications-container']}>
        <Icon
          iconName='notifications'
          className={styles[`biobar-notifications${isVisible ? '-active' : ''}`]}
          onClick={onClick}>
          {
            hasNotifications ?
              <div className={styles['biobar-notifications-new']}></div> :
              <></>
          }
        </Icon>
      </div>
      { isVisible &&
        <Container
          onClick={onClick}
        />
      }
    </>
  );
}

export default Notifications;